import React from "react";
import _ from "underscore";
import PropTypes from "prop-types";
import RadioInputPair from "components/source/shared/radio-input-pair";

class RadioButtonSet extends React.Component {
  static propTypes = {
    defaultValue: PropTypes.string,

    error: PropTypes.string,

    label: PropTypes.string,

    radioButtons: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      })
    ).isRequired,
    onChange: PropTypes.func,
    description: PropTypes.string,
    value: PropTypes.string,
    wrapperClass: PropTypes.string,
    name: PropTypes.string.isRequired,
  };

  renderRadioButtons = () => {
    return (
      <div key="radio-buttons" className="radio-button-set">
        {_.map(
          this.props.radioButtons,
          function (radioButton, i) {
            return (
              <RadioInputPair
                key={i}
                id={this.props.name + "_" + i}
                wrapperClass="radio-button"
                name={this.props.name}
                label={radioButton.label}
                onChange={this.props.onChange}
                description={radioButton.description}
                value={radioButton.value}
                defaultChecked={radioButton.value === this.props.defaultValue}
              />
            );
          },
          this
        )}
      </div>
    );
  };

  renderLabel = () => {
    return (
      <label key="label" {...this.props.labelProps}>
        {this.props.label}
      </label>
    );
  };

  renderErrorMessage = () => {
    return (
      <p key="error" className="error-message color-alert">
        {this.props.error}
      </p>
    );
  };

  render() {
    var className = "input-wrapper";

    if (this.props.error) {
      className += " error";
    }

    return (
      <div className={className}>
        {this.renderLabel()}

        {this.renderRadioButtons()}

        {this.renderErrorMessage()}
      </div>
    );
  }
}

export default RadioButtonSet;
